/**
 * *****************************************************************
 * V1.0
 * User: shaulm
 * Date: 1/7/14
 * *****************************************************************
 */
define(function (require) {
    "use strict";

    var Marionette = require("marionette");
    var template = require("ui/image-carousel/templates/imageCarousel.tmpl");
    var ImageCarouselItemView = require("ui/image-carousel/js/views/ImageCarouselItemView");
    var ImageCarouselCollection = require("ui/image-carousel/js/collections/ImageCarouselCollection");
    var _ = require("underscore");

    var ImageCarousel = Marionette.CompositeView.extend({
        className: "carousel-component",
        itemViewContainer: ".image-carousel-list",
        template: template,
        itemView: ImageCarouselItemView,

        ui:{
            leftArrow:".carousel-arrow-left",
            rightArrow:".carousel-arrow-right"
        },

        events:{
           "click .carousel-arrow-left": "onArrowLeftClick",
           "click .carousel-arrow-right": "onArrowRightClick"
        },

        itemViewOptions: function(model, index) {
            return {
                itemIndex: index
            };
        },

        //--------------------------------------------------------------------

        initialize:function(options){

            options = options || {};

            this._setOptions(options);
            this._bindEvents();
        },

        //--------------------------------------------------------------------

        _setOptions: function(options){

            if (!_.isObject(options.collection)) {
                throw "ImageCarousel -> validateOptions -> collection is not valid.";
            }
            if (_.isFinite(_.result(options.collection,"size")) && options.collection.size() === 0) {
                throw "ImageCarousel -> validateOptions -> collection can not be empty";
            }
            this.selectedImage = options.selectedImage || "";
        },

        //--------------------------------------------------------------------

        _bindEvents:function(){
            this.listenTo(this, "itemview:click", this._handleItemClick);
        },

        //--------------------------------------------------------------------

        onRender:function(){

            this._setSelectedIndex();
            this._updateSelectedView({silent:true});
        },

        //--------------------------------------------------------------------

        _setSelectedIndex:function(){

            this.selectedIndex = 0;

            if(!_.isEmpty(this.selectedImage)){

                this.children.each(_.bind(function(itemView){
                    if(itemView.model.get("src") === this.selectedImage){
                        this.selectedIndex = itemView.itemIndex;
                    }
                },this));
            }
        },

        getDisplayedImage: function(){
            var selectView = this.children.findByIndex(this.selectedIndex);
            return selectView.model.get("src");
        },

        //--------------------------------------------------------------------

        showSelectedView:function(selectView){

            this.children.each(function(itemView){
                itemView.hide();
            });
            selectView.show();
        },

        //--------------------------------------------------------------------

        onArrowLeftClick:function(){

            this.selectedIndex = Math.max(0, this.selectedIndex-1);
            this._updateSelectedView();
        },

        //--------------------------------------------------------------------

        onArrowRightClick:function(){

            this.selectedIndex = Math.min(this.selectedIndex+1, this.collection.size()-1);
            this._updateSelectedView();
        },

        //--------------------------------------------------------------------

        _updateSelectedView:function(options){

            var selectView = this.children.findByIndex(this.selectedIndex);

            if(_.isObject(selectView)){

                this.showSelectedView(selectView);
                this.notifyAll(selectView, options);
                this.setArrows();
            }
        },

        //---------------------------------------------------------------------

        setArrows:function(){

            this.ui.leftArrow.toggleClass("disable", this.selectedIndex  === 0);
            this.ui.rightArrow.toggleClass("disable", this.selectedIndex  === this.collection.size()-1);
        },

        //---------------------------------------------------------------------

        notifyAll:function(selectView, options){

            options = options || {};

            if(!options.silent){
                this.trigger(ImageCarousel.TRIGGERING.CHANGE, selectView.model.get("src"));
            }
        },

        //---------------------------------------------------------------------

        setSelection:function(selection){

            if(!_.isEmpty(selection)){
                this.selectedImage = selection;
                this.onRender();
            }
        },

        //----------------------------------------------------------------------

        _handleItemClick:function(itemView){
            this.notifyAll(itemView);
        }
    });

    ImageCarousel.PERMUTATION = {
        A : "perm-A"
    };

    ImageCarousel.TRIGGERING = {
        CHANGE:"change"
    };


    ImageCarousel.Collection = ImageCarouselCollection;

    return ImageCarousel;
});
